import { connect } from "react-redux";

import ConversionPanel from "../Components/Conversions/ConversionPanel";

const mapStateToProps = (state) => {
  return { locale: state.locale };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ConversionPanel);
